import React from 'react';
import { Loader } from '.';

export const LoaderWrapper: React.FC<{
    loading: boolean;
    label: string;
    children: React.ReactElement;
}> = ({ loading, label, children }) => {
    if (loading) {
        return (
            <>
                <div>{children}</div>
                <div className="bg-gray-900 bg-opacity-90 backdrop-blur-sm flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full">
                    <div className="relative w-full h-full max-w-2xl md:h-auto">
                        <Loader label={label} />
                    </div>
                </div>
            </>
        );
    }
    return children;
};
